import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=64493ab4&scoped=true&"
import script from "./VideoPage.vue?vue&type=script&lang=ts&"
export * from "./VideoPage.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPage.vue?vue&type=style&index=0&id=64493ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64493ab4",
  null
  
)

export default component.exports